import React, { useState } from 'react';
import { User, AlertCircle, CheckCircle } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const StudentLogin = ({ onStudentLogin }) => {
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const value = token.trim();
    if (!value) return setError('Please enter a valid IMS access token');

    setLoading(true);
    setError('');
    try {
      const profileRes = await fetch(`${API_BASE_URL}/api/ipmat/student/profile`, {
        headers: { Authorization: `Bearer ${value}` },
      });
      const profileData = await profileRes.json();
      if (!profileRes.ok || !profileData.success) throw new Error(profileData.error || 'Token validation failed');

      localStorage.setItem('jwtToken', value);
      setSuccess('Login successful');
      onStudentLogin({
        imsPin: profileData.data.studentPin,
        name: profileData.data.name || profileData.data.studentPin,
        loginMethod: 'jwt',
        token: value,
      });
    } catch (err) {
      setError(err.message || 'Failed to login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="bg-indigo-100 rounded-full p-4 inline-block mb-4"><User className="text-indigo-600" size={32} /></div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">IPMAT AI Insights</h1>
          <p className="text-gray-600">Normally this page opens automatically from MyIMS. For local testing, paste a valid access token.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="token" className="block text-sm font-medium text-gray-700 mb-2">IMS access token</label>
            <textarea id="token" value={token} onChange={e => setToken(e.target.value)} rows={4}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
              disabled={loading} autoComplete="off" />
          </div>
          {error && <div className="flex items-center space-x-2 text-red-600 bg-red-50 p-3 rounded-lg"><AlertCircle size={20} /><span className="text-sm">{error}</span></div>}
          {success && <div className="flex items-center space-x-2 text-green-600 bg-green-50 p-3 rounded-lg"><CheckCircle size={20} /><span className="text-sm">{success}</span></div>}
          <button type="submit" disabled={loading} className="w-full bg-indigo-600 text-white py-3 px-4 rounded-lg disabled:opacity-50">
            {loading ? 'Authenticating…' : 'Open IPMAT insights'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default StudentLogin;
